import Chart from "chart.js/auto";

export default function chartsPanel() {
  document.querySelectorAll("canvas.donut[data-stats]").forEach((chartEl) => {
    let items;
    try {
      items = JSON.parse(chartEl.getAttribute("data-stats") || "[]");
    } catch {
      return;
    }

    if (!Array.isArray(items) || !items.length) {
      return;
    } else {
      const labels = items.map((d) => d.label);
      const values = items.map((d) => Number(d.value) || 0);
      const colors = items.map((d) => d.color);

      chartEl.chartInstance = new Chart(chartEl, {
        type: "doughnut",
        data: {
          labels,
          datasets: [{ data: values, backgroundColor: colors, borderWidth: 0 }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 1,
          spacing: 2,
          cutout: "85%",
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          },
        },
      });
    }
  });
}
